import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// New 
const Shop            = () => import('@/views/Shop')
const LeadColor       = () => import('@/views/widgets/LeadColor')
const AutoINN         = () => import('@/views/widgets/AutoINN')
const ChangeLabels    = () => import('@/views/widgets/ChangeLabels')
const Calc            = () => import('@/views/widgets/Calc')
const PeriodSettings  = () => import('@/views/widgets/PeriodSettings')
const ExtendSumHeader = () => import('@/views/widgets/ExtendSumHeader')
const MoveLeadByDate  = () => import('@/views/widgets/MoveLeadByDate')


const Personal        = () => import('@/views/Personal')

Vue.use(Router)

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Главная',
      component: DefaultContainer,
      children: [
        { 
          path: 'dashboard',
          name: 'Панель управления',
          component: Shop
        },
        {
          path: 'shop',
          name: 'Магазин виджетов',
          component: Shop
        },
        {
          path: 'personal',
          name: 'Личный кабинет',
          component: Personal
        },
        {
          path: 'widgets',
          name: 'Виджеты',
          redirect: '/dashboard',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'lead_color',
              name: 'Управление цветами сделок',
              component: LeadColor,
            },
            {
              path: 'auto_inn_bik',
              name: 'Автозаполнение по ИНН / БИК',
              component: AutoINN,
            },
            {
              path: 'change_labels',
              name: 'Переименование полей amoCRM',
              component: ChangeLabels,
            },
            {
              path: 'calc',
              name: 'Калькулятор',
              component: Calc,
            },
            {
              path: 'period_settings',
              name: 'Настройка полей переодичности',
              component: PeriodSettings,
            },
            {
              path: 'extend_sum_header',
              name: 'Дополнительная сумма по сделкам в этапах',
              component: ExtendSumHeader,
            },
            {
              path: 'move_lead_by_date',
              name: 'Перемещение сделки в зависимости от даты',
              component: MoveLeadByDate,
            },
          ]
        }
      ]
    },
  ]
});